 <template>
  <v-dialog v-model="isMediaOpen" scrollable persistent width="750px">
    <v-card>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-file-document-edit</v-icon>เพิ่มสื่อ (เสียง/วิดีโอ)
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="clearData">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <div class="px-10" v-if="typeMedia == 'audio'">
          <!-- <v-radio-group v-model="select_type_audio" row>
            <v-radio label="อัพโหลดไฟล์ใหม่" value="new-audio"></v-radio>
            <v-radio label="เลือกจากไฟล์ที่มีอยู่แล้ว" value="old-audio" disabled></v-radio>
          </v-radio-group>-->
          <v-card
            class="pa-5 mb-5 mt-5 border"
            elevation="0"
            v-show="select_type_audio == 'new-audio'"
          >
            <form class="my-5" action>
              <div class="d-flex">
                <p class="title mb-0">เลือกไฟล์เสียงที่ต้องการ</p>
                <p class="ml-auto subtitle-1 mb-0" style="padding: 5px 0">
                  ประเภทไฟล์นามสกุล mp3/m4a
                </p>
              </div>
              <v-file-input
                outlined
                v-model="file_audio"
                @change="onFileAudioChange"
                accept=".mp3, .m4a"
                prepend-icon="mdi-volume-high"
              ></v-file-input>
            </form>

            <div v-if="successUpload">
              <p class="title">ตัวอย่างไฟล์เสียง</p>
              <vuetify-audio :file="urlAudio" color="primary"></vuetify-audio>
            </div>
            <div v-if="showUploadPercent" class="progressContainerAudio">
              <v-progress-linear v-model="progressPercent" height="25" reactive>
                <strong>{{ progressPercent }}%</strong>
              </v-progress-linear>
              <div class="timeLeft">{{ timeLeft }}</div>
            </div>

            <v-card-actions class="mt-5">
              <v-spacer></v-spacer>
              <v-btn
                elevation="0"
                class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
                outlined
                @click="clearData"
                >Cancel</v-btn
              >
              <v-btn
                elevation="0"
                class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
                @click="insertAudioToQuestion"
                :disabled="!successUpload"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
          <v-card
            class="pa-5 border"
            elevation="0"
            v-show="select_type_audio == 'old-audio'"
          >
            <!-- table -->
            <v-row>
              <v-col cols="12">
                <v-alert v-show="showWarnnig" dense text :type="typeWarning">{{
                  textWarning
                }}</v-alert>
                <div class="mr-md-5 xs-full-width">
                  <v-text-field
                    outlined
                    rounded
                    append-icon="search"
                    placeholder="ค้นหาชื่อไฟล์เสียง"
                    v-model="searchData"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>

            <v-data-table
              :headers="audioHeader"
              :items="audioItem"
              :items-per-page="20"
              hide-default-footer
              class="elevation-1 py-3 my-3"
            >
              <template v-slot:item.url="{ item }">
                <vuetify-audio
                  class="preview-audio"
                  :file="item.url"
                  color="primary"
                  :ended="audioFinish"
                ></vuetify-audio>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  outlined
                  color="success"
                  dark
                  rounded
                  @click="insertToQuestion(item)"
                >
                  <v-icon left>mdi-check</v-icon>เลือก
                </v-btn>
              </template>
            </v-data-table>
            <div class="text-center pt-2">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
          </v-card>
        </div>
        <!--  <v-card-title>Select Country</v-card-title> -->

        <div class="px-10" v-if="typeMedia == 'video'">
          <!-- <v-radio-group v-model="select_type_video" row>
            <v-radio label="อัพโหลดไฟล์ใหม่" value="new-video"></v-radio>
            <v-radio label="เลือกจากไฟล์ที่มีอยู่แล้ว" value="old-video" disabled></v-radio>
          </v-radio-group>-->
          <v-card
            class="pa-5 mb-5 mt-5 border"
            elevation="0"
            v-show="select_type_video == 'new-video'"
          >
            <v-row>
              <v-col>
                <div class="d-flex">
                  <p class="title mb-0">เลือกไฟล์วิดีโอที่ต้องการ</p>
                  <p class="ml-auto subtitle-1 mb-0" style="padding: 5px 0">
                    ประเภทไฟล์นามสกุล MP4
                  </p>
                </div>

                <v-file-input
                  v-model="file_vedio"
                  class="input-file-media"
                  counter
                  outlined
                  :show-size="1000"
                  accept=".mp4"
                  prepend-icon="mdi-video"
                  @change="onFileVideoChange"
                >
                  <template v-slot:selection="{ index, text }">
                    <p>{{ text }}</p>

                    <span
                      v-if="index === 2"
                      class="overline grey--text text--darken-3 mx-2"
                      >+{{ files.length - 2 }} File(s)</span
                    >
                  </template>
                </v-file-input>
              </v-col>
            </v-row>
            <p class="title" v-if="successUpload">ตัวอย่างไฟล์วิดีโอ</p>
            <v-row align="center" justify="center">
              <v-col :lg="10" :md="12" :sm="12" :xs="12" v-if="successUpload">
                <!-- <v-row> -->
                <div v-if="successUpload" class="videoPlayer">
                  <video-player
                    v-if="!isCheckComplete"
                    class="video-player-box videoContainer"
                    ref="videoPlayer"
                    :options="playerOptions"
                    :playsinline="true"
                    customEventName="customstatechangedeventname"
                    @ready="playerReadied"
                  ></video-player>
                  <!-- <iframe src="https://fleet.byteark.com/player?url=http://deknerdteam-yqavnd.cdn.byteark.com/video-objects/RtZ4rjdrAN6F/playlist.m3u8?x_ark_access_id=aJnMS6B3c9K4BUS0KiKz&x_ark_auth_type=ark-v2&x_ark_expires=1584512000556&x_ark_signature=YXjT9XEnQBlZGQJ9k7oYpA" width="100%" height="480" frameborder="0" allowfullscreen></iframe> -->
                </div>
                <!-- </v-row> -->
              </v-col>
              <v-col
                :lg="10"
                :md="12"
                :sm="12"
                :xs="12"
                v-if="successUpload === false"
              >
                <v-row>
                  <v-col :lg="12" :md="12" :sm="12" :xs="12">
                    <div class="container-preview">
                      <v-skeleton-loader
                        class="mx-auto"
                        max-width="100%"
                        type="card"
                        elevation="1"
                      ></v-skeleton-loader>
                      <div v-if="cantGetLink" class="progressContainerError">
                        <!-- <div>{{percent}}</div> -->
                        <v-alert type="error"
                          >ไม่สามารถดูวิดีโอได้ กรุณาลองใหม่อีกครั้ง</v-alert
                        >
                        <div></div>
                      </div>
                      <div
                        v-if="
                          showUploadPercent === false && cantGetLink === false
                        "
                        class="progressContainer"
                      >
                        <!-- <div>{{percent}}</div> -->
                        <v-icon x-large>play_circle_outline</v-icon>
                      </div>
                      <div v-if="showUploadPercent" class="progressContainer">
                        <!-- <div>{{percent}}</div> -->
                        <v-progress-linear
                          v-model="progressPercent"
                          height="25"
                          reactive
                        >
                          <strong>{{ progressPercent }}%</strong>
                        </v-progress-linear>
                        <div class="timeLeft">{{ timeLeft }}</div>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-card-actions class="mt-5">
              <v-spacer></v-spacer>
              <v-btn
                elevation="0"
                class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
                outlined
                @click="clearData"
                >Cancel</v-btn
              >
              <v-btn
                elevation="0"
                class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
                @click="insertVideoToQuestion"
                :disabled="!successUpload"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
          <v-card
            class="pa-5 border"
            elevation="0"
            v-show="select_type_video == 'old-video'"
          >
            <!-- table -->
            <v-row>
              <v-col cols="12">
                <v-alert v-show="showWarnnig" dense text :type="typeWarning">{{
                  textWarning
                }}</v-alert>
                <div class="mr-md-5 xs-full-width">
                  <v-text-field
                    outlined
                    rounded
                    append-icon="search"
                    placeholder="ค้นหาชื่อไฟล์เสียง"
                    v-model="searchData"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>

            <v-data-table
              :headers="audioHeader"
              :items="audioItem"
              :items-per-page="20"
              hide-default-footer
              class="elevation-1 py-3 my-3"
            >
              <template v-slot:item.url="{ item }">
                <vuetify-audio
                  class="preview-audio"
                  :file="item.url"
                  color="primary"
                  :ended="audioFinish"
                ></vuetify-audio>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  outlined
                  color="success"
                  dark
                  rounded
                  @click="insertToQuestion(item)"
                >
                  <v-icon left>mdi-check</v-icon>เลือก
                </v-btn>
              </template>
            </v-data-table>
            <div class="text-center pt-2">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
 <script>
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import axios from 'axios';
import {
  headersWithTokenForImage,
  serverName,
  domain,
  fileServerEndpoint,
} from '@/service/configApi';
import { getPrivateVideo } from '@/service/upload/upload.js';
import $ from 'jquery';
import { getPrivateFile } from '@/service/upload/upload.js';

import videojs from 'video.js';
window.videojs = videojs;

// hls plugin for videojs6
require('videojs-contrib-hls/dist/videojs-contrib-hls.js');

import { generateVodTicket } from '../../../helper/vod';
import { EventBus } from '../../../event-bus';

export default {
  props: {
    isMediaOpen: {
      type: Boolean,
    },
    isMediaClose: {
      type: Function,
    },
    onSetVideo: {
      type: Function,
    },
    onSetAudio: {
      type: Function,
    },
    typeMedia: {
      type: String,
    },
  },
  components: {
    VuetifyAudio: () => import('vuetify-audio'),
    videoPlayer,
  },
  watch: {
    isMediaOpen: async function (value) {
      if (!value) {
        console.log('Yes');
        try {
          // console.log($(".videoPlayer")[0])
          //  $(".videoPlayer")[0].player.pause();
          $('video').each(function () {
            $(this).get(0).pause();
          });
        } catch (error) {
          console.log(error);
        }
        try {
          this.urlAudio = '';
        } catch (error) {
          console.log(error);
        }
        this.clearData();
      }
    },
  },
  data() {
    return {
      //audio
      file_audio: [],
      select_type_audio: 'new-audio',
      audioHeader: [
        { text: 'ชื่อไฟล์', value: 'name', sortable: false },
        {
          text: 'ตัวอย่างเสียง',
          value: 'url',
          sortable: false,
          align: 'center',
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'right',
        },
      ],
      audioItem: [
        {
          name: 'student audio',
          url: 'http://www.hochmuth.com/mp3/Boccherini_Concerto_478-1.mp3',
        },
      ],
      audioUploadId: '',
      audioFile: '',
      urlAudio: '',

      //video
      file_vedio: [],
      select_type_video: 'new-video',
      playerOptions: {
        // videojs options
        fluid: true,
        height: '500',
        // width: '300',
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'video/mp4',
            src:
              'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
          },
        ],
        // poster: "/static/images/author.jpg"
      },
      isCheckComplete: false,
      urlVideo:
        // "https://fleet.byteark.com/player?url=http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8",
        'http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8',
      cantGetLink: false,
      showUploadPercent: false,
      videoUploadId: '',
      videoFile: '',
      percent: '',
      progressPercent: 0,
      successUpload: false,
    };
  },
  methods: {
    clearData() {
      this.isMediaClose();
      this.file_audio = [];
      this.select_type_audio = 'new-audio';
      this.audioHeader = [
        { text: 'ชื่อไฟล์', value: 'name', sortable: false },
        {
          text: 'ตัวอย่างเสียง',
          value: 'url',
          sortable: false,
          align: 'center',
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          align: 'right',
        },
      ];
      this.audioItem = [
        {
          name: 'student audio',
          url: 'http://www.hochmuth.com/mp3/Boccherini_Concerto_478-1.mp3',
        },
      ];
      this.audioUploadId = '';
      this.audioFile = '';
      this.urlAudio = '';

      //video
      this.file_vedio = [];
      this.select_type_video = 'new-video';
      this.playerOptions = {
        // videojs options
        fluid: true,
        height: '500',
        // width: '300',
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'video/mp4',
            src:
              'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
          },
        ],
        // poster: "/static/images/author.jpg"
      };
      this.isCheckComplete = false;
      this.urlVideo =
        // "https://fleet.byteark.com/player?url=http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8",
        'http://deknerdteam-09uxa0.cdn.byteark.com/videos/playlist.m3u8';
      this.cantGetLink = false;
      this.showUploadPercent = false;
      this.videoUploadId = '';
      this.videoFile = '';
      this.percent = '';
      this.progressPercent = 0;
      this.successUpload = false;
      this.showUploadPercent = false;
    },
    async onFileAudioChange(file) {
      console.log('yes', file);
      var myAudios = [];

      window.URL = window.URL || window.webkitURL;
      console.log('file', file);
      this.successUpload = false;
      this.pendingUpload = true;
      this.audioFile = file;
      var fileURL = URL.createObjectURL(file);
      console.log(fileURL);
      myAudios.push(file);
      var audio = document.createElement('audio');
      audio.preload = 'metadata';

      audio.onloadedmetadata = await function () {
        window.URL.revokeObjectURL(audio.src);
        console.log(audio.duration);
        var duration = audio.duration;
        myAudios[myAudios.length - 1].duration = duration;
        // console.log(duration, parseInt(duration, 10))
        this.duration = parseInt(duration, 10) * 1000;
        // console.log(this.duration)
        // console.log(myVideos[0].duration)

        this.showUploadPercent = true;
        this.cantGetLink = false;
        console.log('Uploading');
        this.uploadAudioFile(this.audioFile);
      }.bind(this);

      audio.src = URL.createObjectURL(file);
    },
    async onFileVideoChange(file) {
      console.log('yes', file);
      var myVideos = [];

      window.URL = window.URL || window.webkitURL;
      console.log('file', file);
      this.successUpload = false;
      this.pendingUpload = true;
      this.videoFile = file;
      var fileURL = URL.createObjectURL(file);
      // this.playerOptions.sources[0].src = fileURL; //add this
      console.log(fileURL);

      myVideos.push(file);
      var video = document.createElement('video');
      video.preload = 'metadata';

      video.onloadedmetadata = async function () {
        window.URL.revokeObjectURL(video.src);
        console.log(video.duration);
        var duration = video.duration;
        myVideos[myVideos.length - 1].duration = duration;
        // console.log(duration, parseInt(duration, 10))
        this.duration = parseInt(duration, 10) * 1000;
        // console.log(this.duration)
        // console.log(myVideos[0].duration)

        this.showUploadPercent = true;
        this.cantGetLink = false;
        console.log('Uploading');
        await this.uploadFile(this.videoFile);
      }.bind(this);

      video.src = URL.createObjectURL(file);
    },

    timeToString(time) {
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(time / (1000 * 60 * 60 * 24));
      var hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((time % (1000 * 60)) / 1000);
      let timeString = '';
      // Output the result in an element with id="demo"
      if (days > 0) {
        timeString =
          'เหลือเวลาอีก ' +
          days +
          ' วัน ' +
          hours +
          ' ชั่วโมง ' +
          minutes +
          ' นาที ' +
          seconds +
          ' วินาที ';
      } else if (hours > 0) {
        timeString =
          'เหลือเวลาอีก ' +
          hours +
          ' ชั่วโมง ' +
          minutes +
          ' นาที ' +
          seconds +
          ' วินาที ';
      } else if (minutes > 0) {
        timeString =
          'เหลือเวลาอีก ' + minutes + ' นาที ' + seconds + ' วินาที ';
      } else {
        timeString = 'เหลือเวลาอีก ' + seconds + ' วินาที ';
      }
      return timeString;
    },
    async uploadAudioFile(file) {
      var timeStarted = new Date();
      let formData = new FormData();
      /*
            Add the form data we need to submit
          */
      formData.append('fileupload', file);
      formData.append('title', file.name);

      // formData.append("time", this.duration);

      /*
            Make the request to the POST /single-file URL
          */
      axios
        // .post(`${domain}/uploadfile/private/video/ondemand`, formData, {
        .post(`${domain}/uploadfile/private/file/course`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            this.percent =
              parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              ) + '%';
            this.progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
            let timeElapsed = new Date() - timeStarted;
            let uploadSpeed = progressEvent.loaded / timeElapsed; // Upload speed in millisecond

            // `callback` is the function that shows the time to user.
            // The only argument is the number of remaining seconds.
            this.timeLeft = this.timeToString(
              (progressEvent.total - progressEvent.loaded) / uploadSpeed
            );
          }.bind(this),
        })
        .then(
          async function (response) {
            this.audioUploadId = response.data.result;
            this.urlAudio = await getPrivateFile(this.audioUploadId);
            if (this.urlAudio) {
              this.successUpload = true;
              this.pendingUpload = false;
              this.showUploadPercent = false;
            } else {
              this.showUploadPercent = false;
              (this.cantGetLink = true), (this.pendingUpload = false);
            }
          }.bind(this)
        )
        .catch(function () {
          console.log('FAILURE!!');
        });
    },
    async uploadFile(file) {
      var timeStarted = new Date();
      let formData = new FormData();
      /*
            Add the form data we need to submit
          */
      let ticket = await generateVodTicket();
      formData.append('file', file);
      formData.append('title', file.name);
      formData.append('ticket', ticket);
      // formData.append('image', file);

      formData.append('time', this.duration);
      console.log(this.duration);

      /*
            Make the request to the POST /single-file URL
          */
      axios
        // .post(`${domain}/uploadfile/private/video/ondemand`, formData, {
        .post(`${fileServerEndpoint}/uploadfile/video`, formData, {
          headers: {
            ...headersWithTokenForImage(),
          },
          onUploadProgress: function (progressEvent) {
            this.percent =
              parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              ) + '%';
            this.progressPercent = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
            console.log(this.percent);
            let timeElapsed = new Date() - timeStarted;
            console.log(timeElapsed);
            let uploadSpeed = progressEvent.loaded / timeElapsed; // Upload speed in millisecond

            // `callback` is the function that shows the time to user.
            // The only argument is the number of remaining seconds.
            this.timeLeft = this.timeToString(
              (progressEvent.total - progressEvent.loaded) / uploadSpeed
            );
          }.bind(this),
        })
        .then(
          async function (response) {
            console.log(response);
            console.log('SUCCESS!!');
            console.log(response.data.result);
            this.typeMedia == 'audio'
              ? (this.audioUploadId = response.data.result)
              : (this.videoUploadId = response.data.result);
            let resultLink = await getPrivateVideo(
              this.typeMedia == 'audio'
                ? this.audioUploadId
                : this.videoUploadId
            );
            if (resultLink.isCheckComplete !== undefined) {
              this.isCheckComplete = resultLink.isCheckComplete;
              if (resultLink.isCheckComplete) {
                // this.typeMedia == "audio"
                //   ? (this.urlAudio = resultLink.url)
                //   : (this.urlVideo = resultLink.url);
                if (this.typeMedia == 'audio') {
                  this.urlAudio = resultLink.url;
                } else {
                  this.urlVideo = resultLink.url;
                }

                // this.oldVideoUrl = resultLink.url
              } else {
                // this.typeMedia == "audio"
                //   ? (this.urlAudio =
                //       resultLink.urllocalhost +
                //       `?token=${localStorage.getItem(
                //         "x-session-token"
                //       )}&server=${serverName}`)
                //   : (this.playerOptions.sources[0].src =
                //       resultLink.urllocalhost +
                //       `?token=${localStorage.getItem(
                //         "x-session-token"
                //       )}&server=${serverName}`);
                // console.log(this.urlAudio);

                if (this.typeMedia == 'audio') {
                  this.urlAudio =
                    resultLink.urllocalhost +
                    `?token=${localStorage.getItem(
                      'x-session-token'
                    )}&server=${serverName}`;
                } else {
                  this.playerOptions.sources[0] = {
                    src: resultLink.urllocalhost,
                    type: 'application/x-mpegURL',
                  };
                  this.playerOptions.hls = true;
                }
              }
              //this.urlVideo = `https://fleet.byteark.com/player?url=${resultLink}`;
              this.successUpload = true;
              this.pendingUpload = false;
              this.showUploadPercent = false;

              EventBus.$emit('creditPoint.show');
            } else {
              this.showUploadPercent = false;
              (this.cantGetLink = true), (this.pendingUpload = false);
            }
          }.bind(this)
        )
        .catch(function () {
          console.log('FAILURE!!');
        });
    },
    insertVideoToQuestion() {
      this.onSetVideo(this.videoUploadId);
      this.clearData();
    },
    insertAudioToQuestion() {
      this.onSetAudio(this.audioUploadId);
      this.clearData();
    },
  },
};
</script>

<style lang="scss" scoped>
.v-dialog > .v-card > .v-card__subtitle,
.v-dialog > .v-card > .v-card__text {
  padding: 24px 20px;
}
.preview-audio {
  box-shadow: none;
  background: transparent !important;
  p {
    display: none;
  }
  .v-card__text {
    button:nth-child(2) {
      display: none;
    }
    button:nth-child(3) {
      display: none;
    }
    .v-progress-linear {
      display: none;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
.select-type-audio {
  .v-input--radio-group__input {
    justify-content: center;
  }
}
.border {
  border: 1px solid rgb(195, 195, 195) !important;
}
.dialogStyle {
  height: 1000px;
}
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.buttonTypeContent.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  width: 100%;
  padding-bottom: 50%; /* 1:1 Aspect Ratio */
  padding-top: 50%;
  border-radius: 50px;
}
.textInbutton.v-btn__content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
}
.colCenter {
  text-align: center;
}
.textField {
  width: 100%;
}
.labelAttach.v-label.theme--light {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 30px;
}
p {
  margin: 0 0 5px;
}
.examplePDF {
  /* height: 450px; */
  text-align: center;
}
.iframePDF {
  width: 200px;
  height: 300px;
  /* overflow: hidden; */
}
.iframeWeb {
  width: 100%;
  height: auto;
  /* overflow: hidden; */
}
.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  margin-top: 7%;
}
.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}
.manageButton {
  justify-content: flex-end;
}
.textAreaDetail {
  border-radius: 15px;
}
.labelExplan {
  text-align: justify;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}
/* @media only screen and (max-width: 600px ){
  .col {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}
} */

/* video */
.video-js[tabindex='-1'] {
  width: 100%;
  height: 400px;
}
.videoContainer {
  width: 100%;
  /* height: 400px; */
  margin: 0 auto;
}
@media (max-width: 500px) {
  .videoContainer {
    width: 100%;
    height: auto;
    margin: 0 auto;
  }
}
/* .vjs_video_3{
  width: 200px;
  height: 200px;
} */
.progressContainerAudio {
  max-width: 270px;
  text-align: center;
  width: 90%;
  margin: 0 auto;
}
.progressContainerAudioError {
  max-width: 270px;
  text-align: center;
  width: 90%;
  margin: 0 auto;
  margin-top: -180px;
  margin-bottom: 160px;
}
.progressContainer {
  max-width: 270px;
  text-align: center;
  width: 90%;
  margin: 0 auto;
  margin-top: -160px;
  margin-bottom: 160px;
}
.progressContainerError {
  max-width: 270px;
  text-align: center;
  width: 90%;
  margin: 0 auto;
  margin-top: -180px;
  margin-bottom: 160px;
}

/* @media (max-width: 760px) {
  .progressContainer {
    width: 200px;
  }
} */
.videoPlayer {
  width: 100%;
}
@media (max-width: 760px) {
  .videoPlayer {
    width: 100%;
  }
}
@media (max-width: 760px) {
  .select-type-upload ul li {
    margin: 0 20px;
  }
}
@media (max-width: 375px) {
  .select-type-upload ul li {
    margin: 0 10px;
  }
}
@media (max-width: 360px) {
  .select-type-upload ul li {
    margin: 0 10px;
  }
}
@media (max-width: 320px) {
  .select-type-upload ul li {
    margin: 0 1px;
  }
}

.vs-progress--background {
  width: 100%;
}
.input-group {
  display: table;
  margin: 0 auto;
}
.input-upload {
  display: table-cell;
}
.uploadfile {
  display: none;
}
.input-group-btn {
  background-color: #ec407a;
  border-color: #ec407a;
  color: #fff;
  margin-left: -2px;
  border-radius: 0;
  width: 60px;
  padding: 0.75rem 0rem !important;
}
.vs-con-input-label {
  width: 400px;
}
.timeLeft {
  text-align: right;
}
.vjs_video_3-dimensions {
  width: 100% !important;
  height: 320px;
}
.upload_description {
  font-size: 12px;
  color: grey;
  margin-top: 5px;
}

@media (max-width: 800px) {
  .resonsive-iframe {
    height: 500px;
  }
}
</style>
<style lang="scss">
.v-input.input-file-media.theme--light.v-text-field.v-text-field--is-booted.v-text-field--enclosed.v-text-field--outlined.v-text-field--rounded.v-file-input {
  .v-input__control {
    .v-input__slot {
      .v-text-field__slot {
        .v-label.theme--light {
          top: 8px;
        }
      }
    }
  }
}
.v-input.input-file-media.v-input--is-label-active.v-input--is-dirty.theme--light.v-text-field.v-text-field--is-booted.v-text-field--enclosed.v-text-field--outlined.v-text-field--rounded.v-file-input {
  .v-input__control {
    .v-input__slot {
      .v-text-field__slot {
        .v-label.theme--light {
          top: 18px !important;
        }
      }
    }
  }
}
</style>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
</style>
